import { render, staticRenderFns } from "./RwColorPicker.vue?vue&type=template&id=13518b38"
import script from "./RwColorPicker.vue?vue&type=script&lang=ts"
export * from "./RwColorPicker.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports